import { useUserStore } from '@/storage/user'

export const timezoneResolver = () => {
  useUserStore().setTimezone()
}
